// Body areas and conditions verbatim-derived from the body map on nordicprolo.se (verified 2026-09-28).
// `treatments` = treatments that MAY be relevant (conservative mapping, see VERIFY.md).
// 3D/2.5D anchor positions live in src/content/anchors.js (language-agnostic).
export const bodyAreaGroups = [
  { id: "overkropp", label: "Huvud och överkropp", areas: ["huvud", "nacke", "axel", "armbage", "hand"] },
  { id: "bal", label: "Rygg och bäcken", areas: ["rygg", "backen", "hoft"] },
  { id: "ben", label: "Ben och fot", areas: ["kna", "vad", "fot", "ta"] },
];

export const bodyAreas = [
  {
    slug: "huvud",
    label: "Huvud",
    lead: "Långvarig huvudvärk, käksmärta eller besvär efter en skada mot huvud och nacke.",
    conditions: [
      "Kronisk huvudvärk",
      "Vissa typer av migrän",
      "TMJ/käksmärta",
      "Vissa typer av tinnitus",
      "Whiplashskada",
      "Trigeminusneuralgi (neuropatisk ansiktssmärta)",
      "Besvär efter hjärnskakning (postkontusionellt syndrom)",
    ],
    treatments: ["proloterapi", "nervproloterapi"],
    sourceUrl: "https://nordicprolo.se/huvud/",
  },
  {
    slug: "nacke",
    label: "Nacke",
    lead: "Nacksmärta och stelhet som hänger kvar, till exempel efter whiplash eller en idrottsskada.",
    conditions: [
      "Långvarig nacksmärta",
      "Whiplashskada",
      "Ridskador",
      "Diskbråck",
      "Långvarig smärta efter skada eller idrottsskada",
      "Långvarig smärta efter kirurgi i nacken",
      "Långvarig stelhet i nacken",
      "Cervikal instabilitet",
    ],
    treatments: ["proloterapi", "mls-laser"],
    sourceUrl: "https://nordicprolo.se/nacke/",
  },
  {
    slug: "axel",
    label: "Axel",
    lead: "Axelsmärta, nedsatt kraft eller en axel som känns instabil eller knäpper.",
    conditions: [
      "Kronisk axelsmärta",
      "Långvarig smärta efter axelskada och axelkirurgi",
      "Långvarig smärta efter axelfraktur",
      "Artros",
      "Impingement-syndrom",
      "Minskad kraft i axeln",
      "Idrottsrelaterad axelsmärta",
      "Axelknäppningar",
      "Axelledsinstabilitet",
      "Återkommande axelluxation",
      "Rotatorkuffsyndrom",
      "Domningar och stickningar",
    ],
    treatments: ["proloterapi", "nervproloterapi", "prp"],
    sourceUrl: "https://nordicprolo.se/axel/",
  },
  {
    slug: "armbage",
    label: "Armbåge",
    lead: "Smärta på in- eller utsidan av armbågen, klickljud eller besvär efter en skada.",
    conditions: [
      "Tennisarmbåge (smärta på utsidan av armbågen)",
      "Golfarmbåge (smärta på insidan av armbågen)",
      "Instabilitet i armbågsleden",
      "Artros",
      "Knäppningar eller klickljud i armbågen",
      "Ligamentskada i armbågsleden",
      "Långvarig smärta efter armbågsskada och armbågsoperation",
      "Långvarig smärta efter armbågsfraktur",
      "Idrottsrelaterad smärta",
      "Domningar och stickningar",
    ],
    treatments: ["proloterapi", "nervproloterapi", "prp"],
    sourceUrl: "https://nordicprolo.se/armbage/",
  },
  {
    slug: "hand",
    label: "Hand",
    lead: "Värk, domningar eller stickningar i hand, handled och fingrar.",
    conditions: [
      "Långvarig smärta i handen",
      "Karpaltunnelsyndrom",
      "Överrörlighetsrelaterad smärta i handen",
      "Artros i hand och handled",
      "Domningar och stickningar i handen",
      "Artros i fingrarna",
      "Långvarig smärta i fingrarna",
      "Diabetesneuropati",
      "Idrottsrelaterad smärta",
      "Ehlers-Danlos-relaterad smärta",
      "Handsmärta efter graviditet",
      "Långvarig smärta efter hand- och fingerskada",
      "Långvarig smärta efter hand- eller fingeroperation",
    ],
    treatments: ["proloterapi", "nervproloterapi", "prp", "neuropatiutredning"],
    sourceUrl: "https://nordicprolo.se/hand/",
  },
  {
    slug: "rygg",
    label: "Rygg",
    lead: "Långvarig värk i rygg och ländrygg, nervsmärta eller besvär efter en operation.",
    conditions: [
      "Långvarig (kronisk) smärta i ryggen och ländryggen",
      "Diskbråck",
      "Nervsmärta",
      "Ridskador",
      "Kvarstående bäckensmärta efter graviditet och förlossning",
      "Långvarig smärta efter skada eller idrottsskada",
      "Långvarig smärta efter ryggkirurgi",
    ],
    treatments: ["proloterapi", "nervproloterapi"],
    sourceUrl: "https://nordicprolo.se/rygg/",
  },
  {
    slug: "backen",
    label: "Bäcken",
    lead: "Smärta i bäcken och ljumske, till exempel kvarstående besvär efter en förlossning.",
    conditions: [
      "Långvarig ljumsksmärta",
      "Långvarig smärta i ändtarm/rektum",
      "Långvarig smärta efter förlossning",
      "Bäckensmärta",
    ],
    treatments: ["proloterapi"],
    sourceUrl: "https://nordicprolo.se/backen/",
  },
  {
    slug: "hoft",
    label: "Höft",
    lead: "Höftsmärta vid artros, efter en skada eller efter en höftprotesoperation.",
    conditions: [
      "Höftartros",
      "Smärta efter graviditet",
      "Långvarig smärta efter höftskada eller idrottsskada",
      "Långvarig smärta efter höftprotesoperation",
    ],
    treatments: ["proloterapi", "prp"],
    sourceUrl: "https://nordicprolo.se/hoft/",
  },
  {
    slug: "kna",
    label: "Knä",
    lead: "Knäsmärta vid artros, efter en idrottsskada eller om knät känns instabilt.",
    conditions: [
      "Knäartros (gonartros)",
      "Idrottsskada",
      "Meniskruptur (partiell)",
      "Långvarig smärta efter knäprotesoperation",
      "Ledbandsinstabilitet (ACL, PCL, MCL, LCL)",
      "Löparknä (”runner's knee”)",
      "Långvarig smärta i knäskålen",
    ],
    treatments: ["proloterapi", "prp"],
    sourceUrl: "https://nordicprolo.se/kna/",
  },
  {
    slug: "vad",
    label: "Vad",
    lead: "Värk i vaden, domningar eller smärta i hälsenan.",
    conditions: ["Långvarig smärta i vaden", "Domningar och stickningar i vaden", "Smärta i hälsenan"],
    treatments: ["proloterapi", "nervproloterapi"],
    sourceUrl: "https://nordicprolo.se/vad/",
  },
  {
    slug: "fot",
    label: "Fot",
    lead: "Hälsporre, upprepade stukningar, instabilitet eller domningar i foten.",
    conditions: [
      "Hälsporre (plantar fasciit)",
      "Artros i foten",
      "Hälkuddesyndrom",
      "Domningar och stickningar i foten",
      "Smärta relaterad till diabetesneuropati",
      "Skada på ATFL (främre talofibulära ligamentet)",
      "Långvarig smärta efter skada, kirurgi eller idrottsskada i foten",
      "Långvarig smärta efter fraktur i foten",
      "Upprepade stukningar",
      "Ridskador",
      "Instabilitet i foten",
    ],
    treatments: ["proloterapi", "nervproloterapi", "prp", "neuropatiutredning"],
    sourceUrl: "https://nordicprolo.se/fot/",
  },
  {
    slug: "ta",
    label: "Tå",
    lead: "Artros, domningar eller långvarig smärta i tårna.",
    conditions: [
      "Artros i tån",
      "Domningar och stickningar i tån",
      "Diabetisk neuropati",
      "Långvarig smärta efter skada, kirurgi eller idrottsskada i tån",
      "Långvarig smärta efter fraktur i tån",
    ],
    treatments: ["proloterapi", "nervproloterapi", "prp", "neuropatiutredning"],
    sourceUrl: "https://nordicprolo.se/ta/",
  },
];

export const getArea = (slug) => bodyAreas.find((a) => a.slug === slug);

// "Områden vi behandlar" from nordicprolo.se start page + BokaDirekt profile text.
export const conditionThemes = [
  "Ledvärk",
  "Artros",
  "Idrottsskador",
  "Nervsmärta",
  "Nervskador vid diabetes",
  "Nacksmärta",
  "Axelvärk",
  "Ryggsmärta",
  "Huvudvärk",
  "Fotledssmärta",
  "Ridskador",
  "Smärta efter förlossning",
  "Ehlers-Danlos syndrom / hypermobilitet",
  "Fibromyalgi",
  "TMJ/käksmärta",
  "Långvarig smärta efter operation eller protes",
];
